<template>
  <div>
    <b-button
      v-b-toggle="'list-invisible-training-stats'"
      class="m-1"
      variant="info">Statistiques de consultation</b-button>
    <b-collapse
      id="list-invisible-training-stats">
      <b-row
        class="justify-content-md-center mt-4"
        align-v="center">
        <b-col align-self="center">
          <b-row>
            <b-col>
              <b-form-group
                label="Filtrer"
                label-cols-sm="3"
                label-align-sm="left"
                label-size="sm"
                label-for="filterInput">
                <b-input-group size="sm">
                  <b-form-input
                    id="filterInput"
                    v-model="filter"
                    type="search"
                    placeholder="Taper pour rechercher un document"/>
                  <b-input-group-append>
                    <b-button
                      :disabled="!filter"
                      @click="filter = ''">Effacer</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-table
            :fields="fields"
            :items="statsTraining"
            :filter="filter"
            :filter-included-fields="filterOn"
            small
            responsive="sm">
            <template #cell(doc_id)="row">
              <b-col>{{ row.item.doc_id }}</b-col>
            </template>
            <template #cell(doc_name)="row">
              <b-col>{{ `[${row.item.doc_type}] ${row.item.doc_name}` }}</b-col>
            </template>
            <template #cell(doc_methods)="row">
              <b-button
                :style="{ 'background-color': OPEN }"
                class="mt-2 mb-2">
                Ouvert
                <b-badge variant="light">{{ row.item.doc_methods.OPEN }}</b-badge>
              </b-button>
              <b-button
                :style="{ 'background-color': DOWNLOAD }"
                class="mt-2 mb-2">
                Téléchargé
                <b-badge variant="light">{{ row.item.doc_methods.DOWNLOAD }}</b-badge>
              </b-button>
              <b-button
                :style="{ 'background-color': SHARE }"
                class="mt-2 mb-2">
                Partagé
                <b-badge variant="light">{{ row.item.doc_methods.SHARE }}</b-badge>
              </b-button>
            </template>
            <template #cell(doc_nb_concerned)="row">
              <b-col>{{ row.item.doc_nb_concerned }}</b-col>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-collapse>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex';

export default {
  name: 'ListTrainingStats',
  data() {
    return {
      title: 'Statistiques de consultation des documents de formation',
      fields: [
        {
          doc_id: {
            label: 'Id',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          doc_name: {
            label: 'Documents',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          doc_methods: {
            label: 'Méthodes de consultation',
            sortable: false,
            tdClass: 'align-middle',
          },
        },
        {
          doc_nb_concerned: {
            label: 'Nombre de personnes impactées',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
      ],
      filter: null,
      filterOn: [],
      OPEN: '#72C55A',
      DOWNLOAD: '#b694C9',
      SHARE: '#1C57AE',
    };
  },
  computed: mapState({
    statsTraining: state => state.contracts.statsTraining,
  }),
  mounted() {
    this.getStatsTraining();
  },
  methods: {
    ...mapActions({
      getStatsTraining: 'contracts/getStatsTraining',
    }),
  },
};
</script>
<style>
</style>
